export const GET_INVENTORY_SETTINGS = 'GET_INVENTORY_SETTINGS'
export const UPDATE_INVENTORY_SETTINGS = 'UPDATE_INVENTORY_SETTINGS'
